import { useEffect, useState } from 'react';

// screen behaviour during a tour: on | voice (dark, wakes on voice prompt) | tap (dark, wakes on tap) | off (system may switch off)
const KEY = 'giss_screen_mode';
export const SCREEN_MODES = ['on', 'voice', 'tap', 'off'];
export const getScreenMode = () => (SCREEN_MODES.includes(localStorage.getItem(KEY)) ? localStorage.getItem(KEY) : 'on');
export const setScreenMode = (m) => { localStorage.setItem(KEY, m); window.dispatchEvent(new Event('giss-screen-mode')); };
export const screenPing = () => window.dispatchEvent(new Event('giss-screen-wake'));
export function useScreenMode() {
  const [m, setM] = useState(getScreenMode);
  useEffect(() => { const on = () => setM(getScreenMode()); window.addEventListener('giss-screen-mode', on); return () => window.removeEventListener('giss-screen-mode', on); }, []);
  return m;
}
